<template>
    <div id="cmsAssociationModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="cmsAssociationTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="cmsAssociationTitle">Link Documents</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <h5>{{ document.description }}</h5>
                    <div class="d-flex justify-content-between">
                        <div class="mt-auto font-smaller font-weight-bold">CMS Documents:</div>
                        <div class="w-50">
                            <div class="input-group input-group-sm mb-1 mr-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                                </div>
                                <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
                            </div>
                        </div>                        
                    </div>
                    <table class="table table-sm font-smaller mb-3">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th>PAN</th>
                                <th>DOS</th>
                                <th>Description</th>
                                <th>Submitted</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="filteredDocuments.length">
                                <tr v-for="doc in filteredDocuments" :key="'cms-document-' + doc.id">
                                    <td class="fit">
                                        <div class="custom-control custom-checkbox">
                                            <input :id="'cms-document-checkbox-' + doc.id" type="checkbox" class="custom-control-input" v-model="doc.selected">
                                            <label class="custom-control-label" :for="'cms-document-checkbox-' + doc.id">
                                                <span class="sr-only"></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td class="fit"><i v-if="doc.historical" class="fas fa-history fa-lg text-muted"></i></td>
                                    <td>{{ doc.pan }}</td>
                                    <td>{{ doc.dos }}</td>
                                    <td>{{ doc.description | truncate(80) }}</td>
                                    <td>{{ doc.submitted }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>                    
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="associate()">Link</button>
                    <button class="btn btn-secondary" data-dismiss="modal">Close</button>                    
                </div>                
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() {
        return {
            searchString: '',
            document: null,
            documents: [],
        }
    },
    computed: {
        filteredDocuments: function () {

            const self = this;
             return self.documents.filter(e => e.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
        }
    },
    methods: {
        show: function (document, state) {

            this.document = document;
            axios.get(`/ajax/researcher/clients/${document.client_id}/claims/${document.claim_id}/documents/${document.id}/service-associations`, {
                params: {
                    isHistorical: document.historical
                }
            })
            .then(response => {

                this.documents = response.data.documents;
                $('#cmsAssociationModal').modal('show'); 
            })
            .catch(error => {

                console.log(error);
            });
        },
        associate: function () {

            let selectedDocuments = this.documents.filter(e => e.selected).map(x => x.id);
            axios.post(`/ajax/researcher/clients/${this.document.client_id}/claims/${this.document.claim_id}/documents/${this.document.id}/associate`, {
                isHistorical: this.document.historical,
                documents: selectedDocuments
            })
            .then(response => {

                $('#cmsAssociationModal').modal('hide');
            })
            .catch(error => {

                console.log(error);
                $('#cmsAssociationModal').modal('hide');
            });
        }        
    },
    created() {
        eventHub.$on('show-cms-document-association', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-cms-document-association');
    }     
}
</script>

<style scoped>    
    .font-smaller {
        font-size: .75rem;
    }
</style>